
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiThreewayStackedInleftLeft75 as ObiThreewayStackedInleftLeft75Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-threeway-stacked-inleft-left-75.js';
 
 
 

 
 export const ObiThreewayStackedInleftLeft75 = createComponent({
   react: React,
   tagName: 'obi-threeway-stacked-inleft-left-75',
   elementClass: ObiThreewayStackedInleftLeft75Element,
   events: {
     
   }
  });
 
 